export const checkNativeLocationPermission = (callback) => {
  callback(true)
}
